import React from "react";
import "./css/About.css";
import Shoumik from "./Images/about/shoumik.jpeg";
import Nandini from "./Images/about/nandini.jpeg";
import JVS from "./Images/about/jaiveer.png";
import Mehul from "./Images/about/mehul.jpeg";
import Niharika from "./Images/about/niharika.jpeg";
import "bootstrap/dist/css/bootstrap.css";


function About() {
  return (
    <React.Fragment>
      <div className="about-container">
        <div className="mind-heading">
          <h2 className="minds">MINDS BEHIND INNOMINATE</h2>
        </div>

        <div className="about-us py-4" id="about-us">
          <div className="about-1 about">
            <div className="about-img-div">
              <img src={Shoumik} alt="" className="img-fluid about-img" />
            </div>
            <div className="about-text">
              <p className="designation">Shoumik Bhattacharya <br /><br /> Founder</p>
              <p className="about-text-p">Shoumik is a typical high-school student who cares more about biological facts
                than the latest sports update. Having a special avocation for public speaking, he spends most of his
                time raising motions in a Model UN or refuting his fellow classmates in a debate. But once outside
                his conventional seriousness, he's quite fun with a guitar in his hands and a smile on his face.
                <br /><br /><a href="https://shoumik1602.wixsite.com/website" className="blog-link">Click here to read his
                  Blog!</a>
              </p>
            </div>
          </div>
          <div className="about-2 about">
            <div className="about-img-div">
              <img src={Niharika} alt="" className="img-fluid about-img" />
            </div>
            <div className="about-text">
              <p className="designation">Niharika Rajsaha <br /><br /> Editor-in-Chief</p>
              <p className="about-text-p">I'm Niharika Rajsaha (she/her), student at La Martiniere for Girls. You'd probably find me holed up in my room, All Apologies playing in my atrociously tangled earphones, swooning over the brilliance that is Kahani accompanied by Dickinson and Poe. Sometimes, I switch on the AC and listen to the thunder podcast on Spotify when I miss the rains.
                {/* <br /><br /><a href="https://instagram.com/mehulbhz" className="blog-link">Click here to check him
                  out!</a> */}
              </p>
            </div>
          </div>
          <div className="about-3 about">
            <div className="about-img-div">
              <img src={Nandini} alt="" className="img-fluid about-img" />
            </div>
            <div className="about-text">
              <p className="designation">Nandini Agarwal <br /><br /> Social Media Manager</p>
              <p className="about-text-p">Nandini Agarwal is a writer and an aspiring journalist. She is also the founder
                of the blog- Book Bytes, which markets itself on Instagram and LinkedIn. She has been a TEDx
                panelist and has been awarded several times for her outstanding work in the field of writing.
                <br /><br /><a href="https://nandinisblogonline.wordpress.com/" className="blog-link">Click here to read her
                  Blog!</a>
              </p>
            </div>
          </div>
          <div className="about-4 about">
            <div className="about-img-div">
              <img src={JVS} alt="" className="img-fluid about-img" />
            </div>
            <div className="about-text">
              <p className="designation">Jaiveer S Madan <br /><br /> Editor-in-Chief</p>
              <p className="about-text-p">Jaiveer is a textbook studious student who also happens to be an avid reader and
                a MUNner. He possesses a passion for writing and adding unnecessary commas all over the place.
                <br /><br /><a href="https://jsmblogone.blogspot.com/" className="blog-link">Click here to read his
                  Blog!</a>
              </p>
            </div>
          </div>
          <div className="about-5 about">
            <div className="about-img-div">
              <img src={Mehul} alt="" className="img-fluid about-img" />
            </div>
            <div className="about-text">
              <p className="designation">Mehul Bhattacharya <br /><br /> Editorial consultant</p>
              <p className="about-text-p">Editorial Consultant of Innominate (Inaugral Editor-in-Chief), Mehul is someone
                who exemplifies the term 'busy'. Involved in multiple student journalism initiatives, he is a
                quizzing and public speaking enthusiast who wants to make a difference in the field of media.
                <br /><br /><a href="https://instagram.com/mehulbhz" className="blog-link">Click here to check him
                  out!</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment >
  );
}

export default About;